export default __webpack_public_path__ + "static/HTH_DESKTOP-XL-1a0ab26c2cd4327917b33078bd5174ea.jpg";